import { Dispatch, useContext } from 'react';

import { AppDispatchContext, AppDispatchType, TAppDispatch } from '@Stores';

const useAppDispatch = (): Dispatch<AppDispatchType<TAppDispatch>> => {
  return useContext(AppDispatchContext) as Dispatch<AppDispatchType<TAppDispatch>>;
};
export default useAppDispatch;
